import { z } from "zod";

const MediaDataRoomAudienceShareDialogSchema = z.object({
  selectedParticipantIds: z.array(z.string()),
});

export const getMediaDataRoomAudienceShareDialogSchema = ({
  isUpdating,
}: {
  isUpdating: boolean;
}) =>
  isUpdating
    ? MediaDataRoomAudienceShareDialogSchema
    : MediaDataRoomAudienceShareDialogSchema.extend({
        selectedParticipantIds:
          MediaDataRoomAudienceShareDialogSchema.shape.selectedParticipantIds.min(
            1,
            {
              message: "At least one participant must be selected",
            }
          ),
      });

export type MediaDataRoomAudienceShareDialogFormValues = z.infer<
  typeof MediaDataRoomAudienceShareDialogSchema
>;
